module.exports = __webpack_public_path__ + "img/ic-slider-right-control.4e4a98ed.svg";